<template>
  <div class="cell-content" >
    <div class="cell-content-grid" @click="handleClick">{{initValue}}</div>
    <div class="cell-main-content" style="padding-left:2px" v-if="!disabled">
      <el-popover placement="top" trigger="click" v-model="visible" @hide="handleHide">
        <el-form :model="form" ref="form" :rules="rules" class="cc-form">
        <el-form-item prop="value">
          <el-input ref="enterInput" :value="form.value" maxlength="45" @input="handleInput"   type="textarea" autosize style="width:300px"></el-input>
           <!-- <el-input  :value="form.value" maxlength="45" @input="handleInput" /> -->
        </el-form-item>
        <div style="margin:10px"></div>
        <el-form-item>
          <div style="text-align: right">
          <el-button size="small" plain @click="handleCancel">取消</el-button>
          <el-button size="small" type="primary" @click="handleConfirm('form')">确定</el-button>
          </div>
        </el-form-item>
        </el-form>
        <el-button type="text" slot="reference" :disabled="disabled">
          <i class="el-icon-edit icon" style="cursor: pointer" v-permission="permission" />
        </el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['initValue', 'listName', 'currentTableData', 'permission', 'disabled'],
  inject: ['projectOrder'],
  data() {
    var validateValue = (rule, value, callback) => {
      if (value === '') {
        const msg = {
          'order': '请输入订单名称',
          'schedule': '请输入计划单名称',
          'media': '请输入创意名称',
          'materialLibrary': '请输入素材名称',
          'landingPage': '请输入落地页名称'
        }
        callback(new Error(msg[this.listName]))
      } else {
        callback()
      }
    }
    return {
      form: {
        value: ''
      },
      rules: {
        value: [{ required: true, validator: validateValue, trigger: 'blur' }]
      },
      visible: false
    }
  },
  watch: {
    visible(newValue, oldValue) {
      if (newValue) {
        this.form.value = JSON.parse(JSON.stringify(this.initValue))
        this.$nextTick(() => {
          this.$refs.enterInput.resizeTextarea()
        })
      }
    }
  },
  methods: {
    handleInput(val) {
      let value = val.replace(/\s+/g, '')
      // eslint-disable-next-line
        this.form.value = value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\·\~\！\@\#\¥\%\……\&\*\（\）\——\-\+\=\【\】\{\}\、\|\；\‘\’\：\“\”\《\》\？\，\。\、\`\~\!\#\$\%\^\&\*\(\)\_\[\]{\}\\\|\;\'\'\:\"\"\,\.\/\<\>\?\+\$]/g,''
      )
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form.value)
          this.visible = false
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form.value = this.cloneDeep(this.initValue)
      this.$refs.form.clearValidate('value')
    },
    handleHide() {
      this.$refs.form.clearValidate('value')
      if (this.form.value === '') {
        this.form.value = this.cloneDeep(this.initValue)
      }
    },
    handleClick() {
      if (this.listName !== '') {
        const routerMap = {
          'order': 'adServingManage',
          // 'schedule': 'materialCreative',
          'media': '',
          'materialLibrary': '',
          'landingPage': ''
        }
        if (routerMap[this.listName]) {
          this.projectOrder.searchParam = ''
          this.$router.push({
            name: routerMap[this.listName],
            params: {
              paramsObj: this.currentTableData
            }
          })
        }
      }
    }
  },
  created() {
    this.form.value = JSON.parse(JSON.stringify(this.initValue))
  }
}
</script>

<style lang="stylus" scoped>
.cell-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #606266;
  width: inherit;
}
.cell-content-grid {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor pointer
  width calc(100% - 30px)
}
.cell-main-content
  width 30px
  .el-button
    padding-top 0
    padding-bottom 0

.icon {
  visibility: hidden;
}

.cell-content:hover .icon {
  visibility: visible;
}

.input-place {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.cc-form
  > >>>.el-form-item
        margin-bottom 0px
</style>
